module.exports = __webpack_public_path__ + "img/bg1.0e376f0a.png";